import { DmaCase, DmaCaseType, VesselClassDefinition } from '@/api/ui/requests';
import { numberToLocaleString } from '@/utils/numberFormatUtils';

export function displayVesselClassDefinition(
  vesselClass: VesselClassDefinition | undefined,
  includeLabel = true,
  rangeSeparator = 'to',
  locale = 'en-us'
): string {
  if (!vesselClass) return '';
  let range =
    `${numberToLocaleString(vesselClass.minimumValue, locale)}` +
    ` ${rangeSeparator} ` +
    `${numberToLocaleString(vesselClass.maximumValue, locale)}`;

  if (!vesselClass.minimumValue) {
    range = ` ≤ ${numberToLocaleString(vesselClass.maximumValue, locale)}`;
  } else if (!vesselClass.maximumValue) {
    range = `≥ ${numberToLocaleString(vesselClass.minimumValue, locale)}`;
  }
  return includeLabel ? `${vesselClass.label}: ${range} ${vesselClass.unit}` : `${range} ${vesselClass.unit}`;
}

export function showValueWithUnit(
  value?: string | number | null | undefined,
  unit?: string | null | undefined,
  amountOfDecimals: number | null | undefined = 0,
  locales?: string | string[] | undefined
): string {
  if (value == null) return 'n/a';

  const unitPostfix = unit ? ` ${unit}` : '';
  if (typeof value === 'number') {
    return `${numberToLocaleString(value, locales, amountOfDecimals)}${unitPostfix}`;
  } else {
    return `${value}${unitPostfix}`;
  }
}

export const dmaSortOrder = [DmaCaseType.SPECIFIC, DmaCaseType.GENERIC];

export const sortVesselClassValues = (vesselClass1: VesselClassDefinition, vesselClass2: VesselClassDefinition): number => {
  if (vesselClass1.minimumValue && vesselClass2.minimumValue) return vesselClass1.minimumValue - vesselClass2.minimumValue;
  if (vesselClass1.maximumValue && vesselClass2.maximumValue) return vesselClass1.maximumValue - vesselClass2.maximumValue;
  return vesselClass1.name.localeCompare(vesselClass2.name);
};

export const sortDmaCases = (dmaCases: Array<DmaCase>) =>
  dmaCases?.sort((n1, n2) => {
    const typeComparison = n1.type.localeCompare(n2.type);
    if (typeComparison !== 0) return dmaSortOrder.indexOf(n1.type) - dmaSortOrder.indexOf(n2.type);

    const vesselTypeComparison = n1.vesselType.localeCompare(n2.vesselType);
    if (vesselTypeComparison !== 0) return vesselTypeComparison;

    return sortVesselClassValues(n1.vesselClass, n2.vesselClass);
  }) ?? [];
